import { render, staticRenderFns } from "./appltSetting.vue?vue&type=template&id=ca7e636e&scoped=true"
import script from "./appltSetting.vue?vue&type=script&lang=js"
export * from "./appltSetting.vue?vue&type=script&lang=js"
import style0 from "./appltSetting.vue?vue&type=style&index=0&id=ca7e636e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7e636e",
  null
  
)

export default component.exports